import { Button, Card, Form } from "react-bootstrap";
import FormRow from "../../components/bt/FormRow";
import { useEffect, useState } from "react";
import useFetchData from "../../hooks/useFetchData";
import api from "../../service/api";
import usePushNotificator from "../../hooks/usePushNotificator";
import { act } from "react";

export default function Banners() {
    const [activated, setActivated] = useState(false);
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');

    const bannerDB = useFetchData('banner');

    const [ pushNotification, Notificator ] = usePushNotificator();

    useEffect(() => {
        if(bannerDB) {
            if(bannerDB.data?.title && bannerDB.data?.content) {
                setActivated(true);
                setTitle(bannerDB.data.title);
                setContent(bannerDB.data.content);
            } else {
                setActivated(false);
                setTitle('');
                setContent('');
            }
        }
    }, [bannerDB]);
 
    const saveBanner = async () => {
        let res;
        if(activated) {
            if(title && content) {
                res = await api.post('banner', {title, content});
            } else {
                return;
            }
        } else {
            res = await api.delete('banner');
        }

        if(res.status === 'ok') {
            pushNotification('Bearbeitung erfolgreich', activated ? 'Der Banner wurde erfolgreich erstellt' : 'Der Banner wurde erfolgreich gelöscht', 'success');
            if(!activated) {
                setTitle('');
                setContent('');
            }
            
        } else {
            pushNotification('Interner Fehler', res.message, 'danger');
        }
    }


    return (
        <>
        <h1>Banner auf der Login-Seite</h1>
        <Notificator />
        <p>Hier können Banner verwaltet werden, die auf der Login-Seite für alle zu sehen sein werden.</p>
        <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
                Banner erstellen / bearbeiten
                <Form.Check type="checkbox" label="Banner aktivieren" id="testid" checked={activated} onChange={(e) => setActivated(e.target.checked)} />
            </Card.Header>
            {activated ? (
            <Card.Body>
                <FormRow label="Titel">
                    <input type="text" className="form-control" value={title} onChange={(e) => setTitle(e.target.value)} />
                </FormRow>
                <FormRow label="Inhalt">
                    <textarea className="form-control" rows={5} value={content} onChange={(e) => setContent(e.target.value)}></textarea>
                </FormRow>
                
            </Card.Body>
            ) : (
                <Card.Body className="text-muted text-center">
                    <em>--- Der Banner ist deaktiviert. ---</em>
                </Card.Body>
            )}
        </Card>
        <div className="text-end mt-3">
           <Button type="submit" variant="success" disabled={activated && (!title || !content)} onClick={saveBanner}>Speichern</Button>
        </div>
        </>
    )
}